import { FC } from 'react';
import {
  Alert,
  AlertDescription,
  AlertTitle,
  Box,
  Heading,
  Icon,
} from '@chakra-ui/react';
import { ParagraphCommentFragment } from '../../../generated/types';
import slugify from '../../../utils/slugify';
import { HTMLText } from '../../Common/HTMLText';
import { ImQuotesLeft } from '@react-icons/all-files/im/ImQuotesLeft';
import { ImQuotesRight } from '@react-icons/all-files/im/ImQuotesRight';
import Link from 'next/link';

interface CommentProps {
  data: ParagraphCommentFragment;
}

export const Comment: FC<CommentProps> = ({ data }) => {
  return (
    <Box pos="relative" bg="gray.100" borderRadius="sm" p={6}>
      <Icon
        as={ImQuotesLeft}
        pos="absolute"
        top={4}
        left={8}
        fontSize="8rem"
        color="primary"
        opacity=".1"
        zIndex={0}
        pointerEvents="none"
      />
      {data.headline && (
        <Heading variant="textHeading" as="div" fontSize="xl" mb={3}>
          {data.headline}
        </Heading>
      )}

      <HTMLText text={data.text} />
      {(data.person || data.author) && (
        <Box
          textAlign="right"
          color="primaryDark"
          fontSize="sm"
          fontWeight="bold"
          fontStyle="italic"
        >
          {data.person ? (
            <Link href={data.person.url} passHref>
              <Box as="a">{data.person.title}</Box>
            </Link>
          ) : (
            data.author
          )}
        </Box>
      )}
      <Icon
        pointerEvents="none"
        as={ImQuotesRight}
        pos="absolute"
        bottom={4}
        right={8}
        fontSize="8rem"
        color="primary"
        opacity=".1"
        zIndex={0}
      />
    </Box>
  );
};
